<!-- 分享图片生成TEST -->
<template>
    <div class="container">
        <div class="share-img">
            <img :src="imgUrl" alt="分享图">
        </div>
        <div class="creat-img" ref="box">
            <img src="@/assets/recruit/bg.png" alt="分享背景图">
            <div id="qrcode" class="qrcode"></div>
        </div>
        <!-- <canvas id="canvass">对不你，你的浏览器不支持Canvas</canvas> -->
        <!-- <div class="box" @click.self="box">
            <div class="son1" @click="son1"></div>
            <div class="son2" @click.stop="son2"></div>
        </div> -->

    </div>
</template>

<script>
import { qrcanvas } from 'qrcanvas';
import html2canvas from 'html2canvas';

export default {
    name: 'Canvas',
    data () {
        return {
            imgUrl:'',
        }
    },
    watch:{
        imgUrl(val, oldval){
            //监听到imgUrl有变化以后 说明新图片已经生成 隐藏DOM
            this.$refs.box.style.display = "none";
        }
    },
    created() {
        let that = this;
        that.$nextTick(function () {
           //生成二维码
           var canvas1 = qrcanvas({
                data: 'https://www.baidu.com',
                size: 64
            });
            document.getElementById("qrcode").innerHTML = '';
            document.getElementById('qrcode').appendChild(canvas1);

            //合成分享图
            that.$indicator.open({
                text: '正在生成图片...',
                spinnerType: 'fading-circle'
            });
            html2canvas(that.$refs.box).then(function(canvas) {
                that.imgUrl =  URL.createObjectURL(that.base64ToBlob(canvas.toDataURL()))                
                setTimeout(()=>{
                    that.$indicator.close(); 
                    that.$toast({
                        message: '图片已生成，长按保存分享给你的好友吧',
                        position: 'middle',
                        duration: 3000
                    });                   
                },2000)
            });
        })
    },
    mounted () {
        // var canvass = document.getElementById("canvass")
        // var ctxt = canvass.getContext('2d');
        // var img = new Image;
        // img.onload = function(){
        //     ctxt.drawImage(img, 0, 0);
        //     var data = ctxt.getImageData(0, 0, img.width, img.height).data;//读取整张图片的像素。
        //     console.log(data, data.toString());
        // }
        // img.src = require('@/assets/recruit/bg.png');//src也可以是从文件选择控件中取得。
    },
    
    methods: {
        //base64转blob
        base64ToBlob(code) {
            let parts = code.split(';base64,');
            let contentType = parts[0].split(':')[1];
            let raw = window.atob(parts[1]);
            let rawLength = raw.length;

            let uInt8Array = new Uint8Array(rawLength);

            for (let i = 0; i < rawLength; ++i) {
            uInt8Array[i] = raw.charCodeAt(i);
            }
            return new Blob([uInt8Array], {type: contentType});
        }
    }
}

</script>
<style lang='less' scoped>
.container{
    width: 100%;
    height: 100vh;
    position: relative;
    top: 0;
    left: 0;
    font-size: 0;
}
.share-img{
    img{
        width: 100%;
        height: 100vh;
    }
}
.creat-img{
    img{
        z-index: 3;
        width: 100%;
        height: 100vh;
    }
    .qrcode{
        position: absolute;
        bottom: 0.12rem;
        left: 0.26rem;
        // margin-left: -64px;
        z-index: 5;
    }
}
</style>